<template>
    <div class="list">
        <el-table v-loading="listLoading" :data="list" border style="width: 100%" align="center" @selection-change="handleSelectionChange">
            <el-table-column type="selection" label="选择" width="55" align="center"></el-table-column>
            <el-table-column label="文章封面" align="center">
                <template slot-scope="scope">
                    <viewer v-if="scope.row.img">
                        <img :src="imgDomain + scope.row.img" class="viewer-img">
                    </viewer>
                </template>
            </el-table-column>

            <el-table-column prop="title" label="文章名称" align="center" />
            <el-table-column prop="article_class_name" label="所属分类" align="center" />
            <el-table-column prop="article_tag_name" label="所属标签" align="center" />
            <el-table-column label="状态" width="80" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.status === 1 ? '显示' : '隐藏' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="push_time" label="发布时间" align="center" />
            <el-table-column prop="create_time" label="创建时间" align="center" />
        </el-table>

        <div class="page"><pagination v-show="total > 0" :total="total" :page.sync="listQuery.page_index" :limit.sync="listQuery.page_size" @pagination="getList" /></div>
        <div class="btn-wrap">
            <el-button @click="back">返回</el-button>
            <el-button type="primary" @click="confirmRelate">确认关联</el-button>
        </div>
    </div>
</template>
<script>
import { getArticle, addArticleRecommendRecord } from '@/api/college.js';
import Pagination from '@/components/Pagination';
import { imgDomain } from '@/configs/env';
export default {
    components: { Pagination },
    data() {
        return {
            imgDomain,
            list: [],
            total: 0,
            listQuery: {
                page_index: 1,
                page_size: 10
            },
            article_id: [],
            listLoading: false
        };
    },

    async mounted() {
        this.getList();
    },

    methods: {
        async getList(params = this.listQuery) {
            this.listLoading = true;
            const { total, data } = await getArticle(params);
            this.listLoading = false;
            this.total = total;
            this.list = data;
        },

        handleSelectionChange(val) {
            this.article_id = [];
            for (const { id } of val) {
                this.article_id.push(id)
            }
        },

        async confirmRelate() {
            if (!this.article_id.length) {
                return this.$notify.error({ title: '请选择关联的文章' });
            }
            const params = { article_id: this.article_id }
            const res = await addArticleRecommendRecord(params);
            if (res == true) {
                this.$notify({ title: '关联文章成功', type: 'success' });
                this.back()
            } else {
                this.$notify.error({ title: '操作失败' });
            }
        },

        back() {
            this.$router.go(-1);
        }
    }
};
</script>

<style lang="less" scoped>
    .list{
        .add{
            float: right;
            margin-bottom: 20px;
        }
        .button_wrap{
            text-align: center;
            margin-top: 30px;
        }
        .el-form-item:last-child{
            margin-bottom: 0;
        }
        .op_buttton{
            margin-bottom: 10px;
        }
        .viewer-img{
            width: 124px;
            height: 80px;
        }
        .btn-wrap{
            margin-top: 20px;
            text-align: center;
        }
    }
</style>
